import SafeLocalStorage from '../utils/SafeLocalStorage';

interface CartTransaction {
  id: string;
  transactionId: string;
  checkoutUrl: string;
}

class CartService {
  private static readonly CART_TRANSACTION_KEY = 'cart_transaction';

  setCartTransaction(transaction: CartTransaction): void {
    SafeLocalStorage.setItem(CartService.CART_TRANSACTION_KEY, transaction);
  }

  getCartTransaction(): CartTransaction | null {
    return SafeLocalStorage.getItem(CartService.CART_TRANSACTION_KEY);
  }

  clearCartTransaction(): void {
    SafeLocalStorage.removeItem(CartService.CART_TRANSACTION_KEY);
  }
}

export default new CartService(); 
